import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useOrderContext } from '../OrderProvider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Property from '@afosto/app-components-react/Property';
import capitalize from '@afosto/utils/string/capitalize';
import {
  boolean as booleanFormatter,
  datetime as datetimeFormatter,
} from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const OrderStatusSection = () => {
  const intl = useIntl();
  const { order, client } = useOrderContext();
  const {
    is_confirmed: isConfirmed = false,
    is_accepted: isAccepted = false,
    is_finished: isFinished = false,
    is_locked: isLocked = false,
    progress = {},
  } = order.state || {};
  const { allocation, billing, fulfilment } = progress ?? {};
  const {
    created_at: createdAt = null,
    type,
    updated_at: updatedAt,
    last_accepted_at: lastAcceptedAt,
    last_confirmed_at: lastConfirmedAt,
  } = order ?? {};
  const { reference } = order.settings ?? {};

  const getProgressTranslation = value => {
    if (!value) {
      return undefined;
    }

    return intl.formatMessage({
      id: `orderProgressStatus.${value}`,
      defaultMessage: capitalize(value),
      description: `Translation of order progress status ${value}`,
    });
  };

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Property label={intl.formatMessage(translations.overview.reference)} value={reference} />
        <Property
          label={intl.formatMessage(translations.overview.type)}
          value={
            type &&
            intl.formatMessage({
              id: `orderTypeOptions.${type}`,
              defaultMessage: type,
              description: `Label of the order type ${type}`,
            })
          }
        />
        <Property label={intl.formatMessage(translations.overview.client)} value={client?.name} />
        <Property
          label={intl.formatMessage(translations.overview.createdAt)}
          value={datetimeFormatter(createdAt)}
        />
        <Property
          label={intl.formatMessage(translations.overview.updatedAt)}
          value={datetimeFormatter(updatedAt)}
        />
        <Property
          label={intl.formatMessage(translations.overview.isAccepted)}
          value={booleanFormatter(isAccepted)}
        />
        <Property
          label={intl.formatMessage(translations.overview.lastAcceptedAt)}
          value={datetimeFormatter(lastAcceptedAt)}
        />
        <Property
          label={intl.formatMessage(translations.overview.isConfirmed)}
          value={booleanFormatter(isConfirmed)}
        />
        <Property
          label={intl.formatMessage(translations.overview.lastConfirmedAt)}
          value={datetimeFormatter(lastConfirmedAt)}
        />
        <Property
          label={intl.formatMessage(translations.overview.isLocked)}
          value={booleanFormatter(isLocked)}
        />
        <Property
          label={intl.formatMessage(translations.overview.isFinished)}
          value={booleanFormatter(isFinished)}
        />

        <Property
          label={intl.formatMessage(translations.overview.allocationProgress)}
          value={getProgressTranslation(allocation)}
        />

        <Property
          label={intl.formatMessage(translations.overview.billingProgress)}
          value={getProgressTranslation(billing)}
        />

        <Property
          label={intl.formatMessage(translations.overview.fulfilmentProgress)}
          value={getProgressTranslation(fulfilment)}
        />
      </CardContent>
    </Card>
  );
};

export default OrderStatusSection;
